/** Helpers UI para planes comerciales; la matriz canónica siempre viene del backend. */

export const COMMERCIAL_PLAN_IDS = ["basic", "professional"];

export const COMMERCIAL_PLAN_LABELS = {
  basic: "Básico",
  professional: "Profesional",
};

export function commercialPlanLabel(planId) {
  return COMMERCIAL_PLAN_LABELS[String(planId || "").toLowerCase()] || "Licencia legacy";
}

export function commercialPlanMatrix(catalog = {}) {
  return catalog?.published?.plans || catalog?.plans || {};
}

export function commercialPlanOptions(catalog = {}) {
  const matrix = commercialPlanMatrix(catalog);
  return COMMERCIAL_PLAN_IDS
    .filter((id) => matrix[id])
    .map((id) => ({
      id,
      label: matrix[id]?.label || commercialPlanLabel(id),
      entitlements: matrix[id]?.entitlements || {},
      limits: matrix[id]?.limits || {},
      pricing: matrix[id]?.pricing || {},
    }));
}

export function commercialPlanOption(catalog = {}, planId) {
  return commercialPlanOptions(catalog).find((plan) => plan.id === planId) || null;
}

export function commercialPlanModuleIds(plan = {}) {
  return Object.entries(plan?.entitlements || {})
    .filter(([, enabled]) => Boolean(enabled))
    .map(([id]) => id);
}

export function commercialPlanPriceLabel(plan = {}, cadence = "annual") {
  const row = plan?.pricing?.[cadence] || {};
  const amount = Number(row.amount_minor || 0) / 100;
  if (!Number.isFinite(amount)) return "—";
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: row.currency || "MXN",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function billingCadenceLabel(cadence) {
  return String(cadence || "").toLowerCase() === "monthly" ? "Mensual" : "Anual";
}
